import React, { useState, useEffect } from "react";
import ProductsManager from "../../modules/productManager";
import { Line } from "react-chartjs-2";

const ProductsChart = ({ routerProps }) => {
  const [products, setAllProducts] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [dateAmount, setDateAmount] = useState([]);

  const getProducts = () => {
    ProductsManager.getProducts().then((resp) => {
      setAllProducts(resp);
    });
  };

  const monthPostedArray = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];

  function filterByPostDate(arrayOfDates) {
    const postDateArray = [];
    const CURRENT_YEAR = 2022;
    arrayOfDates.forEach((date) => {
      const filteredProducts = products.filter((prod) => {
        return prod.created_at.includes(`${CURRENT_YEAR}-${date}`);
      });
      postDateArray.push(filteredProducts.length);
    });
    setDateAmount(postDateArray);
    return postDateArray;
  }

  const productChart = () => {
    const chartColor = "rgba(75, 192, 192, 0.6)";
    setChartData({
      labels: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      datasets: [
        {
          label: "Product Post Data",
          data: filterByPostDate(monthPostedArray),
          backgroundColor: [chartColor],
          borderWidth: 4,
        },
      ],
    });
  };

  useEffect(() => {
    getProducts();
  }, []);

  useEffect(() => {
    productChart();
  }, [products]);

  return (
    <div>
      <Line data={chartData} height={80} />
    </div>
  );
};
export default ProductsChart;
